import React, { useState, useContext, useEffect } from 'react';
import { Button, BookingContext } from '@sirkka-health/booking-system-ui';
import { getRequest } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { buildGeneralCartObject } from '@/helpers/addToCart';

const LocationList = ({
	type,
	service,
	selectedServiceItem,
	selectedEntityItem,
	bookingEntityId,
	referrerParam,
	availableLocations = [],
}) => {
	const [locationData, setLocationData] = useState([]);
	const [isLoadingLocations, setIsLoadingLocations] = useState(false);

	const { bookingData, setBookingData } = useContext(BookingContext);
	const navigate = useNavigate();

	useEffect(() => {
		const fetchData = async () => {
			try {
				setIsLoadingLocations(true);
				let data;

				if (service.service.service_type === 'Postal') {
					setLocationData([
						{
							locationCategory: 'By post',
							building_name: '',
							street: '',
							city: '',
							postcode: '',
						},
					]);
				} else {
					const url =
						type === 'imaging'
							? `/bookings/bookingEntities/service/${service.service.service_id}`
							: `/bookings/location/entity/${bookingEntityId}/service/${service.service.service_id}`;
					data = await getRequest(url);

					if (type === 'imaging' && data && Array.isArray(data.entities)) {
						data = data.entities.sort((a, b) => a.city.localeCompare(b.city));
					} else if (Array.isArray(data)) {
						data = data.sort((a, b) => a.city.localeCompare(b.city));
					} else {
						console.error('Unexpected data structure:', data);
						data = []; // Provide a fallback to avoid breaking the app
					}

					setLocationData(data);
				}
			} catch (error) {
				console.error('Error fetching location data:', error);
			} finally {
				setIsLoadingLocations(false);
			}
		};

		fetchData();
	}, [service, bookingEntityId, type]);

	const formatAddress = (location) => {
		const parts = [location.building_name, location.street, location.city, location.postcode];
		return parts.filter((part) => part).join(', ');
	};

	const addServiceToCart = (location) => {
		const processed = buildGeneralCartObject(location, selectedServiceItem, selectedEntityItem);
		setBookingData([...bookingData, processed]);
		navigate('/cart');
	};

	const handleLocationSelection = (location) => {
		if (location.location_category_id === 5 || location.location_id === 4) {
			// Navigate to home visit page with full selectedServiceItem data
			navigate('/booking/home-visit', { state: { selectedServiceItem, bookingEntityId } });
		} else {
			// Add service to cart for non-home visit locations
			addServiceToCart(location);
		}
	};

	return (
		<div>
			{service.service.service_type !== 'Postal' && (
				<>
					<h5>Available Locations:</h5>
					{isLoadingLocations ? (
						<p>Loading available locations...</p>
					) : locationData.length > 0 ? (
						locationData.map((location, index) => (
							<div
								className="d-flex align-items-center"
								key={`location-${index}`}
								style={{
									backgroundColor: index % 2 === 0 ? 'transparent' : '#f2f2f2',
									padding: '12px',
								}}
							>
								<div className="col-6">
									<h6 className="m-0">{location.city}</h6>
									<p className="m-0">{formatAddress(location)}</p>
								</div>

								{type !== 'imaging' ? (
									<div className="col-6 justify-content-end d-flex">
										<Button
											label={`Select ${location.city}`}
											disabled={false}
											variant="border"
											onClick={() => handleLocationSelection(location)}
										/>
									</div>
								) : (
									<div className="col-6 justify-content-end d-flex">
										<Button
											label={`Contact Us`}
											disabled={false}
											variant="border"
											onClick={() =>
												window.open(
													'https://www.sirkkahealth.com/contact',
													'_blank',
													'noopener noreferrer'
												)
											}
										/>
									</div>
								)}
							</div>
						))
					) : (
						<p>No locations found.</p>
					)}
				</>
			)}

			{service.service.service_type === 'Postal' && (
				<>
					<h5>Service is available by post:</h5>
					<div className="d-flex align-items-center" style={{ padding: '12px' }}>
						<div className="col-6">
							<h6 className="m-0">By post</h6>
							<p className="m-0">Delivered to you to take at home.</p>
						</div>
						<div className="col-6 justify-content-end d-flex">
							<Button
								label="Select By post"
								disabled={false}
								variant="border"
								onClick={() =>
									addServiceToCart({ building_name: '', street: '', city: '', postcode: '' })
								}
							/>
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default LocationList;
